import { render, staticRenderFns } from "./TutorialOverlay.vue?vue&type=template&id=9c869d74&scoped=true"
import script from "./TutorialOverlay.vue?vue&type=script&lang=ts"
export * from "./TutorialOverlay.vue?vue&type=script&lang=ts"
import style0 from "./TutorialOverlay.vue?vue&type=style&index=0&id=9c869d74&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c869d74",
  null
  
)

export default component.exports